import axios from 'axios';
import { HttpRequest } from 'Api/request.utils';

import { getQueryVariable, updateProp } from 'Utils/utils';

export default class ClientApi extends HttpRequest {
  constructor() {
    super();
    this.initialize();
  }
  initialize = () => {
    try {
        const fileUrl = getQueryVariable('fileurl');
        const serviceMode = getQueryVariable('service_mode');
        if(!fileUrl || serviceMode != 'client' ) return
        const baseUrl = this.getBaseUrl(fileUrl);
        let axiosClient = axios.create({
          baseURL: baseUrl,
        });
        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
    } catch (error) {
      throw error;
    }
  };
  close =()=>{
    const url = `/close`
    return this.get({ url })
  }
  getBaseUrl=(url)=>{
   let the_url = url;
   let first_split = the_url.split("//");

   let without_resource = first_split[1];

   let second_split = without_resource.split("/");

   let domain = `${first_split[0]}//${second_split[0]}`;
  
    return domain
  }
  getAxiosClient = (baseURL, timeout = 0) =>{
    let axiosClient = axios.create({
      baseURL
    })
    axiosClient.interceptors.response.use(function(res) {
      return res;
    })
    axiosClient.defaults.timeout = timeout;
    return axiosClient
  }
  checkPortStatus = (_url) => {
    let axiosClient = this.getAxiosClient(_url, 400);
    return axiosClient.get('/status');
  }
  getConnectPort = async (baseUrl, port) => {
    let connectPort = '';
    let fn = async () => {
      let _port = '';
      for (let __port = port; __port < (port + 16); __port++) {
        // 交替循环 当前循环的端口号 + 默认端口和
        try {
          let _url = `${baseUrl}:${__port}`;
          let res = await this.checkPortStatus(_url);
          if (res) {
            if (res.status === 200) {
              _port = __port;
              break;
            }
          }
        } catch (error) {
          try {
            let _url = `${baseUrl}:${port}`;
            let res = await this.checkPortStatus(_url);
            if (res) {
              if (res.status === 200) {
                _port = port;
                break;
              }
            }
          } catch (error) {
          }
        }
      }
      return _port;
    }

    for (let index = 0; index < 10; index++) { // 默认上面 _port + 15 端口号执行 10此 循环
      connectPort = await fn();
      if (connectPort) {
        break;
      }
    }
    return connectPort;
  }
  saveFileRequest = async ({file, auto_open, open_phantom, fileName, baseUrl, connectPort, file_path}) =>{
    let fd = new FormData();
    fd.append('file', file, fileName);
    let baseURL = `${baseUrl}:${connectPort}`;
    let axiosClient = this.getAxiosClient(baseURL);
    let url = '/save';
    return axiosClient.post(url, fd, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        auto_open,
        open_phantom,
        file_path
      }
    })
  }
  openFileRequest = async (open_phantom, baseUrl, connectPort, file_path) => {
    let baseURL = `${baseUrl}:${connectPort}`;
    let axiosClient = this.getAxiosClient(baseURL);
    let url = '/open';
    return axiosClient.get(url, {
      params: {
        open_phantom,
        file_path
      }
    });
  }
  startEditorCloudApp = ({baseUrl, port}) => {
    let href = `FoxitPDFEditorCloud://port=${port}`;
    updateProp(location, 'href', href);
    return new Promise((resolve) => {
      setTimeout( async () => {
        let connectPort = '';
        try {
          connectPort = await this.getConnectPort(baseUrl, parseInt(port));
        } catch (error) {
          connectPort = '';
        }
        resolve(connectPort)
      }, 300)
    })
  }
  saveLocalFile = async ({serviceModeOfClientInfo, docModified, connectPort, auto_open = false, open_phantom = false}, file) => {
    let { filePath: file_path, baseUrl, fileName } = serviceModeOfClientInfo;
    let msg = '';
    let statusCode = 0;
    try {
      if (connectPort) {
        let requestRes;
        if (!docModified && auto_open) {
          requestRes = await this.openFileRequest(open_phantom, baseUrl, connectPort, file_path);
        } else {
          requestRes = await this.saveFileRequest({file,  auto_open, open_phantom, fileName, baseUrl, connectPort, file_path});
        }
        if (requestRes) {
          statusCode = requestRes.status;
        }
      } else {
        msg = 'NoConnectPort'
      }
    } catch (error) {
      msg = error;
    }
    return { statusCode, msg };
  }
  checkEditorCloudApplicationStatus = async ({ baseUrl, port }) => {
    let isStart = false;
    try {
      let _url = `${baseUrl}:${port}`;
      let res = await this.checkPortStatus(_url);
      if (res) {
        if (res.status === 200) {
          isStart = true;
        }
      }
    } catch (error) {
      isStart = false;
    }
    return isStart;
  }
}
